export default __webpack_public_path__ + "static/media/07.47f494ae.jpg";